import { render } from "./LegalView.vue?vue&type=template&id=4c0332c1&scoped=true&ts=true"
import script from "./LegalView.vue?vue&type=script&lang=ts"
export * from "./LegalView.vue?vue&type=script&lang=ts"

import "./LegalView.vue?vue&type=style&index=0&id=4c0332c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0332c1"]])

export default __exports__